import getBroadcastTypeLabel from './get-broadcast-type-label';
import Text from '@ui/text/text/text';
import Container from '@ui/container/container';
import { TBroadcastTypePickerOptions } from './broadcast-type-picker.types';
import getBroadcastTypeIcon from './get-broadcast-type-icon';

type TSelectedBroadcastTypePillProps = {
  broacastType: TBroadcastTypePickerOptions;
};

const SelectedBroadcastTypePill = ({ broacastType }: TSelectedBroadcastTypePillProps) => {
  const label = getBroadcastTypeLabel(broacastType);
  const icon = getBroadcastTypeIcon(broacastType);
  return (
    <Container
      background="var(--gray-800)"
      borderColor="rgba(255, 255, 255, 0.1)"
      borderWidth="1px"
      className="flex ai-flex-center jc-flex-center gap-4"
      borderRadius="100px"
      padding="0 12px"
      height="32px"
    >
      {/* note: adding pointer-events-none because svg prevents click bubble */}
      <div className="flex ai-center pointer-events-none">{icon}</div>
      <Text className="S3 flex ai-center" height={'100%'} whiteSpace="nowrap">
        {label}
      </Text>
    </Container>
  );
};

export default SelectedBroadcastTypePill;
